// Marakin staff levels (users.platform_role). v53, 29 Oct 2026: 'owner'
// (Stuart's account, at most one) sits above 'super_admin' and can do
// everything a super admin can — mirrors backend middleware/platformAuth.js
// staffRoleAllows. Use these instead of comparing to 'super_admin' directly.
export const isOwner = (role) => role === 'owner';
export const isSuperAdminOrOwner = (role) => role === 'super_admin' || role === 'owner';

const LABELS = { owner: 'Owner', super_admin: 'Super admin', admin: 'Admin' };
export const staffRoleLabel = (role) => LABELS[role] || (role ? String(role).replace('_', ' ') : '');
